import React, { useState, useEffect } from 'react'
import { Checkbox, Col, Button, Form, Input, Row, Select, InputNumber, Typography, Popconfirm, Divider, Table, DatePicker, Modal } from "antd";
import { BOM } from "../../../../../services/definedMethod";
import cnt from "../../../../../services/definedConstant";
import { PlusOutlined, CloseOutlined } from "@ant-design/icons";

import TextArea from "antd/es/input/TextArea";
import { apiConfig, labelConfig, staticConfig } from "../../../customer.config";
import CustomButton from '../../../../../components/custom/CustomButton';

const { Text } = Typography

const ChargesForm = (props) => {

    const {
        onFinish,
        form,
        formData,
        userData,
        chargeOptions,
        loanCollateralOptions,
        chargeTableSource,
        setChargeTableSource,
        setCollateralTableSource,
        collateralTableSource,
        setChargesValue,
        setIsLoading

    } = props

    const { session } = userData;
    const [collateralTableCount, setCollateralTableCount] = useState(0)
    const [chargeTableCount, setChargeTableCount] = useState(0)
    const [selectedCharge, setSelectedCharge] = useState(null);
    const [collateralFormData, setCollateralFormData] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    useEffect(() => {
        setChargesValue(chargeTableSource);
    }, [chargeTableCount]);


    //   FOR CHARGES !!!! FOR CHARGES!!!!
    const disabledAfterCurrentDate = (current) => {
        return current && current.valueOf() > Date.now();
    };

    const handleSelectedCharge = (chargeId) => {
        console.log(chargeId);
        setSelectedCharge(chargeId);
    };

    const handleDelete = (key) => {
        const newData = chargeTableSource.filter((item) => item.key !== key);
        setChargesValue(newData);
        setChargeTableSource(newData);
    };

    const handleCollateralDelete = (key) => {
        const newData = collateralTableSource.filter((item) => item.key !== key);
        // setChargesValue(newData);
        setCollateralTableSource(newData);
    };

    const defaultChargesColumns = [
        {
            title: "Name",
            dataIndex: "name",
        },
        {
            title: "Type",
            dataIndex: "type",
        },

        {
            title: "Amount",
            dataIndex: "amount",
            render: (_, record) => {
                // const handleSelectedOptionOne = (value) => {
                //   console.log(record);

                //   setSelectedOptionOne(value);
                // };

                return (
                    <Form.Item
                        name={`amount${record.key}`}
                        initialValue={record.amount}
                    >
                        <InputNumber
                        // style={{ width: "30vh" }}
                        //   onChange={()=> console.log(record)}
                        />
                    </Form.Item>
                );
            },
        },

        {
            title: "Collected On",
            dataIndex: "collectedOn",
        },

        {
            title: "Date",
            dataIndex: "date",
            render: (_, record) => (
                <Form.Item
                    name={`dueDate${record.key}`}
                    initialValue={record.dueDate}
                >
                    <DatePicker
                    // disabledDate={disabledAfterCurrentDate}
                    // defaultValue={
                    />
                </Form.Item>
            )
        },

        {
            title: "Actions",
            dataIndex: "actions",
            render: (_, record) =>
                chargeTableSource.length >= 1 ? (
                    <Popconfirm
                        title="Sure to delete?"
                        onConfirm={() => handleDelete(record.key)}
                        okText="OK"
                        cancelText="Cancel"
                        okButtonProps={{
                            style: {
                                backgroundColor: "#15CCAE",
                                color: "white",
                                height: "15%",
                                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                            },
                        }}
                        cancelButtonProps={{
                            style: {
                                height: "15%",
                                backgroundColor: "white",
                                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                            },
                        }}
                    >
                        <CloseOutlined
                            style={{
                                color: "#92428B",
                                fontSize: "15px",
                                fontWeight: "bolder",
                            }}
                        />
                    </Popconfirm>
                ) : null,
        },
    ];
    const defaultCollateralColumns = [

        {
            title: "Type",
            dataIndex: "type",
        },
        {
            title: "Value",
            dataIndex: "value",
        },
        {
            title: "Description",
            dataIndex: "description",
        },
        {
            title: "Actions",
            dataIndex: "actions",
            render: (_, record) =>
                collateralTableSource.length >= 1 ? (
                    <Popconfirm
                        title="Sure to delete?"
                        onConfirm={() => handleCollateralDelete(record.key)}
                        okText="OK"
                        cancelText="Cancel"
                        okButtonProps={{
                            style: {
                                backgroundColor: "#15CCAE",
                                color: "white",
                                height: "15%",
                                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                            },
                        }}
                        cancelButtonProps={{
                            style: {
                                height: "15%",
                                backgroundColor: "white",
                                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                            },
                        }}
                    >
                        <CloseOutlined
                            style={{
                                color: "#92428B",
                                fontSize: "15px",
                                fontWeight: "bolder",
                            }}
                        />
                    </Popconfirm>
                ) : null,
        },
    ];

    const repaymentInfoColumns = [

        {
            title: "Date",
            dataIndex: "date",
        },
        {
            title: "Days",
            dataIndex: "days",
        },
        {
            title: "Disbursement",
            dataIndex: "disbursement",
        },
        {
            title: "Principal Due",
            dataIndex: "principalDue",
        },

        {
            title: "Principal Balance",
            dataIndex: "pricipalBalance",
        },

        {
            title: "Interest Due",
            dataIndex: "interestDue",
        },

        {
            title: "Fees",
            dataIndex: "fees",
        },

        {
            title: "Penalty",
            dataIndex: "penalty",
        },

        {
            title: "Dues",
            dataIndex: "dues",
        }
    ];

    const handleSave = (row) => {
        const newData = [...chargeTableSource];
        const index = newData.findIndex((item) => row.key === item.key);
        const item = newData[index];
        newData.splice(index, 1, {
            ...item,
            ...row,
        });
        setChargeTableSource(newData);
    };


    const chargesColumns = defaultChargesColumns.map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (record) => ({
                record,
                editable: col.editable,
                dataIndex: col.dataIndex,
                title: col.title,
                handleSave,
            }),
        };
    });

    const collateralColumns = defaultCollateralColumns.map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (record) => ({
                record,
                editable: col.editable,
                dataIndex: col.dataIndex,
                title: col.title,
                handleSave,
            }),
        };
    });


    const handleChargesAdd = () => {

        const url = `${apiConfig.charges}/${selectedCharge}?template=true`;

        const body = {
            session,
        };
        // return;

        setIsLoading(true);

        BOM.FetchReqAction(
            body, url, (err, res) => {
                if (err) {
                    BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
                } else {
                    const objList = res;

                    const handleAdd = () => {
                        const newData = {
                            key: chargeTableCount,
                            id: objList?.id ? objList?.id : "-",
                            name: objList?.name ? objList?.name : "-",
                            type: objList?.chargeCalculationType?.value
                                ? objList?.chargeCalculationType?.value
                                : "-",
                            amount: objList?.amount,
                            //   amountToUse: objList?.amount ? objList?.amount : 0,
                            collectedOn: objList?.chargeTimeType?.value
                                ? objList?.chargeTimeType?.value
                                : "-",
                        };
                        setChargeTableSource([...chargeTableSource, newData]);
                        setChargeTableCount(chargeTableCount + 1);
                    };

                    handleAdd();

                    // STOP LOAD
                    setIsLoading(false);
                    // console.log(chargeTableSource);
                }
            }
        );
    };



    const handleValuesChange = (changedValues, allValues) => {
        setCollateralFormData(allValues)
    }

    const handleCollateralAdd = (formValues) => {

        const newData = {
            key: collateralTableCount,
            id: collateralTableCount,
            type: collateralFormData.collateralId,
            value: collateralFormData.collateralValue,
            description: collateralFormData.description,
        };
        setCollateralTableSource([...collateralTableSource, newData]);

        setCollateralTableCount(collateralTableCount + 1);
    };

    return (
        <Form
            layout="vertical"
            onFinish={onFinish}
            form={form}
            initialValues={formData}
            onValuesChange={handleValuesChange}
        >

            <Row style={{ justifyContent: "space-between" }}>
                <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item label={labelConfig.charge} name={"chargeId"}>
                        <Select
                            placeholder={BOM.handlePlaceholderMsg(
                                `${labelConfig.charge}`,
                                "select"
                            )}
                            options={chargeOptions}
                            onChange={handleSelectedCharge}
                        />
                    </Form.Item>
                </Col>

                <Col span={8} style={{ padding: "0px 8px" }}>

                    <Form.Item>
                        <Button
                            type="primary"
                            shape='round'
                            icon={<PlusOutlined />}
                            style={{
                                backgroundColor: "#15CCAE",
                                color: "white",
                                width: "15vh",
                                marginTop: 30,
                            }}
                            onClick={handleChargesAdd}
                        >
                            Add
                        </Button>
                    </Form.Item>
                </Col>
                <Col span={8}>
                    <div></div>
                </Col>
            </Row>
            <Table columns={chargesColumns} dataSource={chargeTableSource}></Table>

            <Col span={24} style={{ padding: "0px 8px" }}>
                <Row style={{ justifyContent: "space-between", marginTop: 20 }}>
                    <Col span={8} style={{ padding: "0px 8px" }}>
                        <Form.Item
                            label={labelConfig.collateral}
                            name="collateralId"
                            rules={[
                                {
                                    required: true,
                                    message: BOM.CheckReqFld(labelConfig.collateral),
                                },
                            ]}
                        >
                            <Select
                                placeholder={BOM.handlePlaceholderMsg(
                                    `${labelConfig.collateral}`,
                                    "select"
                                )}
                                showSearch
                                options={loanCollateralOptions}
                            // onChange={onCollateralChange}

                            />
                        </Form.Item>
                    </Col>

                    <Col span={8} style={{ padding: "0px 8px" }}>

                        <Form.Item
                            label={<Text >{labelConfig.value}</Text>}
                            name="collateralValue"

                        >
                            <Input
                                placeholder={BOM.handlePlaceholderMsg(labelConfig.value)}

                            />
                        </Form.Item>
                    </Col>

                    <Col span={8}>
                        <div></div>
                    </Col>

                    <Col span={12} style={{ padding: "0px 8px" }}>

                        <Form.Item
                            label={<Text strong hidden>{labelConfig.collateral}</Text>}
                            name="description"
                        >
                            <TextArea
                                placeholder={BOM.handlePlaceholderMsg(labelConfig.description)}

                            />
                        </Form.Item>
                    </Col>

                    <Col span={12} style={{ padding: "0px 8px" }}>

                        <Form.Item>
                            <Button
                                type="primary"
                                icon={<PlusOutlined />}
                                style={{
                                    backgroundColor: "#15CCAE",
                                    color: "white",
                                    width: "15vh",
                                    marginTop: 30,
                                }}
                                onClick={handleCollateralAdd}
                            >
                                Add
                            </Button>
                        </Form.Item>
                    </Col>

                    <Col span={24} style={{ padding: "0px 8px" }}>
                        <Table columns={collateralColumns} dataSource={collateralTableSource}></Table>
                    </Col>

                </Row>
            </Col>

            <RepaymentInfoModal
                repaymentInfoColumns={repaymentInfoColumns}
                isModalOpen={isModalOpen}
                setIsModalOpen={setIsModalOpen}
                setIsLoading={setIsLoading}
                session={session} />
        </Form>

    );
}

export default ChargesForm


const RepaymentInfoModal = (props) => {
    const { repaymentInfoColumns, isModalOpen, setIsModalOpen, setIsLoading, session } = props;
    const [useForm] = Form.useForm();
    const [repaymentInfoList, setRepaymentInfoList] = useState([]);

    const getDetail = () => {
        const params = {
            command: "calculateLoanSchedule",
        };

        const url = `${apiConfig.LoanAccounts}`;

        let body = {
            session,
            params,
        };

        setIsLoading(true);

        BOM.FetchReqAction(body, url, (err, res) => {
            if (err) {
                BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
                setIsLoading(false);
            } else {
                const objDetail = res;

                let tempRepaymentInfoArray = [];

                objDetail?.periods?.forEach((element) => {
                    tempRepaymentInfoArray.push({
                        key: element?.id,
                        id: element?.id,
                        date: element?.dueDate ? BOM.DateTime(element?.dueDate, "only-date") : "-",
                        days: element?.daysInPeriod ? element?.daysInPeriod : "-",
                        disbursement: element?.principalDisbursed ? element?.principalDisbursed : "-",
                        principalDue: element?.principalDue ? element?.principalDue : "-",
                        pricipalBalance: element?.principalLoanBalanceOutstanding ? element?.principalLoanBalanceOutstanding : "-",
                        interestDue: element?.interestDue ? element?.interestDue : "-",
                        fees: element?.feeChargesDue ? element?.feeChargesDue : "-",
                        penalty: element?.penaltyChargesDue ? element?.penaltyChargesDue : "-",
                        dues: element?.totalDueForPeriod ? element?.totalDueForPeriod : "-",
                    });
                });

                setRepaymentInfoList(tempRepaymentInfoArray);
                setIsLoading(false);
            }
        });
    };

    const handleClick = () => {
        setIsModalOpen(true);
        getDetail();
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };


    return (
        <Row>
            <Button
                type="primary"
                shape='round'
                onClick={handleClick}
                style={{
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                    backgroundColor: "#15CCAE",
                    marginBottom: 20,
                    marginTop: 20
                }}
            >{labelConfig.repaymentInfo}</Button>

            <Modal
                title="Repayment Information"
                open={isModalOpen}
                footer={null}
                onCancel={handleCancel}
                width={1000}
            >

                <Form
                    form={useForm}
                    layout="vertical"
                    name="address-info"
                >

                    <Divider />

                    <Table
                        columns={repaymentInfoColumns}
                        dataSource={repaymentInfoList} />

                    <Row>
                        <CustomButton
                            content="Cancel"
                            style={{
                                width: "10%",
                                marginLeft: "auto",
                                marginTop: 20,
                                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                            }}
                            backgroundColor="#fff"
                            colorText="black"
                            hoverBackground="#F5F5F5"
                            onClick={() => setIsModalOpen(false)}
                        />
                    </Row>
                </Form>
            </Modal>
        </Row>
    );
};